import React from 'react'
import Banners from '../../Components/Banners/Banners'
import Products from '../../Components/Products/Products'
import Testimonios from '../../Components/Testimonios/Testimonios'
import Sucursales from '../../Components/Sucursales/Sucursales'
import './Demo.css'
import Footer from '../../Components/Footer/Footer'
import BtnWhatsapp from '../../Components/BtnWhatsapp/BtnWhatsapp'
import Cart from '../../Components/Cart/Cart'
import InstallPWA from '../../Components/InstallPWA/InstallPWA'
export default function Demo() {
    return (
        <section className='demo'>
            <Banners />
            <Products />
            <Testimonios />
            <Sucursales />
            <Footer />
            <BtnWhatsapp />
            <Cart />
            <InstallPWA />
        </section>
    )
}
